<script>

export default {
  props: {
    vehicles: {
      type: Array,
      default: () => [],
    },
    fuelCalibration: {
      type: Array,
      default: () => [],
    },
    rangeHigh: {
      type: Number,
      default: () => null,
    },
    rangeLow: {
      type: Number,
      default: () => null,
    },
    sensorCode: {
      type: Number,
      default: () => null,
    },
  },

  data() {
    return {
      loading: true,
      sortBy: '',
      sortDesc: false,
      validation: {},
      isValid: false, // Add this line
    }
  },
  computed: {
    calibrateFields() {
      if (this.show_model && this.show_model.length > 0) {
        const result = this.show_model.map((a) => a.key)
        return this.calibrateField.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.calibrateField
      }
    },

    calibrateField() {
      return [
        {
          key: 'no',
          label: this.$t('global.number'),
        },
        {
          key: 'sensor_value',
          label: this.$t('global.value'),
        },
        {
          key: 'actual_value',
          label: this.$t('global.volume'),
        },
        {
          key: 'action',
          label: '',
        },
      ]
    },
  },

  watch: {
    fuelCalibration: {
      handler(newFuelCalibration) {
        this.validateDuplicateValues(newFuelCalibration)
      },
      deep: true,
    },
  },

  methods: {
    handleError(error) {
      if (error.response) {
        this.$toast.error(error.response.data.error)
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
      return
    },

    async addItem() {
      this.fuelCalibration.push({
        vehicle_id: this.vehicles[0].vehicle_id,
        sensor_value: 0,
        actual_value: 0,
        sensor_type: this.sensorCode,
      })

      await this.$nextTick()
      const index = this.fuelCalibration.length - 1

      document.getElementById(`sensor_value_${index}`).scrollIntoView()
    },

    removeItem(index) {
      this.fuelCalibration.splice(index, 1)
    },

    updateItem(index, field, value) {
      this.fuelCalibration[index][field] = parseFloat(value)
    },

    validateDuplicateValues(fuelCalibration) {
      const validation = {}
      this.isValid = true
      fuelCalibration.forEach((item, index) => {
        if (
          item.sensor_value === null ||
          item.sensor_value === undefined ||
          item.sensor_value === ''
        ) {
          this.$set(validation, `sensor_value_${index}`, this.$t('global.requiredField'))
          this.isValid = false
        } else {
          this.$set(validation, `sensor_value_${index}`, null)
        }

        if (
          item.actual_value === null ||
          item.actual_value === undefined ||
          item.actual_value === ''
        ) {
          this.$set(validation, `actual_value_${index}`, this.$t('global.requiredField'))
          this.isValid = false
        } else if (item.actual_value < 0) {
          this.$set(validation, `actual_value_${index}`, this.$t('global.nonNegativeValueError'))
          this.isValid = false
        } else {
          this.$set(validation, `actual_value_${index}`, null)
        }

        if (this.isFieldDuplicate('sensor_value', item.sensor_value, index)) {
          this.$set(validation, `sensor_value_${index}`, this.$t('global.duplicateValueError'))
          this.isValid = false
        }

        if (this.isFieldDuplicate('actual_value', item.actual_value, index)) {
          this.$set(validation, `actual_value_${index}`, this.$t('global.duplicateValueError'))
          this.isValid = false
        }

        let maxRange = this.rangeHigh
        let minRange = this.rangeLow
        if (this.rangeLow > this.rangeHigh) {
          maxRange = this.rangeLow
          minRange = this.rangeHigh
        }

        if (item.sensor_value < minRange || item.sensor_value > maxRange) {
          this.$set(validation, `sensor_value_${index}`, this.$t('global.rangeValueError'))
          this.isValid = false
        }
      })

      this.validation = validation
    },

    isFieldDuplicate(field, value, currentIndex) {
      return this.fuelCalibration.some(
        (item, index) => index !== currentIndex && item[field] === parseFloat(value)
      )
    },
  },
}
</script>

<template>
  <div>
    <div class="table-responsive my-3 border border-1" style="max-height: 570px; overflow-y: auto">
      <b-table
        :items="fuelCalibration"
        :fields="calibrateFields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        :empty-text="$t('global.emptyTable')"
        :busy="loading"
        striped
        bordered
        outlined
      >
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(sensor_value)="data">
          <b-form-input
            :id="`sensor_value_${data.index}`"
            type="number"
            v-model="data.item.sensor_value"
            @input="updateItem(data.index, 'sensor_value', data.item.sensor_value)"
            :state="validation[`sensor_value_${data.index}`] ? false : null"
          >
          </b-form-input>
          <b-form-invalid-feedback v-if="validation[`sensor_value_${data.index}`]">
            {{ validation[`sensor_value_${data.index}`] }}
          </b-form-invalid-feedback>
        </template>
        <template #cell(actual_value)="data">
          <b-form-input
            :id="`actual_value_${data.index}`"
            type="number"
            v-model="data.item.actual_value"
            @input="updateItem(data.index, 'actual_value', data.item.actual_value)"
            :state="validation[`actual_value_${data.index}`] ? false : null"
          >
          </b-form-input>
          <b-form-invalid-feedback v-if="validation[`actual_value_${data.index}`]">
            {{ validation[`actual_value_${data.index}`] }}
          </b-form-invalid-feedback>
        </template>
        <template #cell(action)="data">
          <b-button @click="removeItem(data.index)" variant="danger">
            <i class="fa fa-times" style="color: white; display: block; margin: 0 auto"></i>
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="flex-grow-1">
      <b-button @click="addItem" variant="primary" class="w-100">
        <i class="fa fa-plus" style="margin: 0; vertical-align: middle"></i>
      </b-button>
    </div>
  </div>
</template>
